import { extend } from 'vee-validate'
import { integer, max, required, regex } from 'vee-validate/dist/rules'

const installCustomValidateRules = () => {
  extend('required', required)

  extend('regex', {
    ...regex,
    params: [...regex.params, 'literalAuthorizedChar'],
    message: `Le champ {_field_} ne doit contenir que {literalAuthorizedChar}`,
  })

  extend('max', max)
  extend('integer', integer)
}
export default installCustomValidateRules
